export default __webpack_public_path__ + "static/fb-editorial-postpartum-dbf822332a11840b8e5e484ca46886f7.jpg";